module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "460px",
      "value": _vm.showModal,
      "effect": "fade",
      "backdrop": false
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body confirmation-modal-body ",
    staticStyle: {
      "height": "80px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('center', [_c('span', {
    staticClass: "glyphicon glyphicon-repeat glyphicon-spin",
    staticStyle: {
      "font-size": "30px",
      "color": "#5b9bd5"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a64dc56","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/progress-modal.vue
// module id = 1022
// module chunks = 0